
export default {
  getDetailInfoData: '/courier-sqp-api/h5/v3/serviceScore/detail'
}
